import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../../Auth";
import { Button, Card, Col, Container, FormGroup, FormLabel, Row } from "react-bootstrap";
import { ChevronLeft, PlusLg, Save } from "react-bootstrap-icons";
import { fetchApi, getDefaultData, getStructure } from "../../../Funciones";
import { Campo, Formulario, TipoCampo } from "../../Formulario";
import { Acordeon } from '../../Acordeon';
import { ModuleData, ModuleField, ModulePanel, ModuleSelector } from "../../ModuleLib";


export const Edit: React.FC<{ id?: any }> = ({ id }) => {

	const params = useParams()
	let nav = useNavigate();
	let auth = useAuth()

	const [PID, setPID] = useState("")
	const [data, setData] = useState(new FormData());

	const [estructura, setEstructura] = useState<ModuleData[]>([])
	const [instanceNumber, setInstanceNumber] = useState(1)
	const [navegacion, setNavegacion] = useState<any[]>([])
	const [navegacionFull, setNavegacionFull] = useState<any[]>([])
	const [plantillas, setPlantillas] = useState<any[]>([])

	const getData = async (pid: any) => {
		var resp = await fetchApi(auth.user.token, "page", {
			cmd: "get",
			nav: 1,
			fullNav: 1,
			templates: 1,
			id: pid
		})
		if (resp.nav) {
			setNavegacion(resp.nav)
		}
		if (resp.fullNav) {
			setNavegacionFull(resp.fullNav)
		}
		if (resp.templates) {
			setPlantillas(resp.templates)
		}
		if (resp.estado === "ok") {
			var d = new FormData();
			["title", "description", "parent", "active", "hidden", "useParentMenu", "redir", "template"].forEach(campo => {
				d.set(campo, resp[campo])
			});
			var es = JSON.parse(resp["structure"].replaceAll("\n", "\\n").replaceAll("\r", "\\r").replaceAll("\t", "\\t"))
			setEstructura(await getStructure(es))
			setInstanceNumber(es.length + 1)
			setData(d)
		}
	}

	useEffect(() => {
		if (auth.user) {
			var pid = ""
			var d = new FormData();

			if (id && id !== "") {
				pid = id
			}
			else {
				if (params.id && params.id !== "") {
					pid = params.id
				}
			}

			if (pid !== "") {
				getData(pid)
			}
			else {
				getData(0)
				d.set("redir", "-1")
				setData(d)
			}
			setPID(pid)
		}
		// eslint-disable-next-line
	}, [auth.user, params.id, id])

	const submit = async (ev: any) => {
		var es: any = []
		estructura.forEach(data => {
			data.Module!.getFields().forEach((field: ModuleField) => {
				if (field.mapSaveData) {
					data.Data!.set(field.name, field.mapSaveData(data.Data!.get(field.name)))
				}
			})
			es.push({
				module: data.Module!.getModuleName(),
				data: Object.fromEntries(data.Data!)
			})
		})

		data.set("cmd", "save")
		data.set("pid", PID)
		data.set("structure", JSON.stringify(es))
		let res = await fetchApi(auth.user.token, "page", data)
		if (res.estado === "ok") {
			nav(-1)
		}
		else {
			alert(res.msg)
		}
	}

	const change = (ev: any) => {
		//validaciones
		let d = new FormData()
		data.forEach((val, key) => {
			d.set(key, val)
		})
		if (ev.target.targetElm) { //editor
			d.set(ev.target.targetElm.name, ev.target.getContent())
		}
		else if (ev.target.type !== "file") {
			d.set(ev.target.name, ev.target.value)
		}
		else {
			if (ev.target.files.length > 0)
				d.set(ev.target.name, ev.target.files[0])
			else
				d.delete(ev.target.name)
		}
		setData(d)
	}

	const agregarModulo = async (modulo: any) => {
		var nueva = estructura
		//nueva.push({ Module: modulo, Data: new Map<string, any>(), Instance: instanceNumber })
		nueva.push({ Module: modulo, Data: await getDefaultData(modulo), Instance: instanceNumber })
		setEstructura(nueva)
		setInstanceNumber(instanceNumber + 1)
	}
	const eliminarModulo = (data: ModuleData) => {
		setEstructura(estructura.filter((value) => value.Instance !== data.Instance))
	}
	const colapsarModulo = (data: ModuleData) => {
		setEstructura(estructura.map(item => {
			if (data.Instance === item.Instance) {
				item.Collapsed = !item.Collapsed
				return item
			}
			else {
				return item;
			}
		}))
	}
	const actualizarModulo = (data: ModuleData, field: ModuleField, value: any) => {
		setEstructura(estructura.map(item => {
			if (data.Instance === item.Instance) {
				item.Data!.set(field.name, value)
				return item
			}
			else {
				return item;
			}
		}))
	}
	
	return <>
		<Button size="sm" variant="dark" onClick={() => { nav(-1) }} className="my-2"><ChevronLeft /> Volver</Button>
		<Formulario submit={(ev: any) => submit(ev)} change={(ev: any) => change(ev)} datos={data}>

			<h4>{PID !== "" ? "Editar" : "Nueva"} Página <Button type="submit" variant="primary"><Save /> Guardar</Button></h4>
			<Row>
				<Col xs={8}>
					<Card className="shadow">
						<Acordeon
							header={<Card.Header className="bg-dark text-white">Información</Card.Header>}
							body={<Card.Body>
								<FormGroup className="form-floating">
									<Campo tipo={TipoCampo.Texto} nombre="title" required />
									<FormLabel className="text-primary" htmlFor="title">Título</FormLabel>
								</FormGroup>
								<FormGroup className="form-floating mt-3">
									<Campo tipo={TipoCampo.AreaTexto} rows={3} nombre="description" />
									<FormLabel className="text-primary" htmlFor="form_description">Descripción</FormLabel>
								</FormGroup>
							</Card.Body>} />
					</Card>
					<Card className="shadow mt-2">
						<Acordeon
							header={<Card.Header className="bg-dark text-white">Navegación</Card.Header>}
							body={<Card.Body>
								<FormGroup className="form-floating">
									<Campo tipo={TipoCampo.Select} nombre="parent" required>
										<option value=""></option>
										{navegacion.map((nav: any) => <option key={nav.id} value={nav.id}>{nav.title}</option>)}
									</Campo>
									<FormLabel className="text-primary" htmlFor="parent">Padre</FormLabel>
								</FormGroup>
								<Row className="mt-3">
									<Col>
										<FormGroup className="form-floating">
											<Campo tipo={TipoCampo.Select} nombre="redir" required>
												<option value="-1">No</option>
												{navegacionFull.map((nav: any) => <option key={nav.id} value={nav.id} disabled={nav.id === PID}>{nav.title}</option>)}
											</Campo>
											<FormLabel className="text-primary" htmlFor="redir">Redirección</FormLabel>
										</FormGroup>
									</Col>
									<Col>
										<FormGroup className="form-floating">
											<Campo tipo={TipoCampo.Select} nombre="template" required>
												<option value=""></option>
												{plantillas.map((p: any) => <option key={p.id} value={p.id}>{p.title}</option>)}
											</Campo>
											<FormLabel className="text-primary" htmlFor="template">Plantilla</FormLabel>
										</FormGroup>
									</Col>
								</Row>
								<Row className="mt-2">
									<Col>
										<FormGroup className="active">
											<Campo tipo={TipoCampo.Checkbox} nombre="active" label="Página Activa" />
										</FormGroup>
									</Col>
									<Col>
										<FormGroup className="hidden">
											<Campo tipo={TipoCampo.Checkbox} nombre="hidden" label="Navegación Oculta" />
										</FormGroup>
									</Col>
									<Col>
										<FormGroup>
											<Campo tipo={TipoCampo.Checkbox} nombre="useParentMenu" label="Utilizar Menú Padre" />
										</FormGroup>
									</Col>
								</Row>
							</Card.Body>} />
					</Card>
					{data.get("redir")?.toString() === "-1" && <Card className="shadow mt-2">
						<Acordeon
							header={<Card.Header className="bg-dark text-white">Estructura</Card.Header>}
							body={<Card.Body className="p-0">
								{estructura.map((data: ModuleData, i: number) => {
									return <ModulePanel
										key={data.Instance + "_" + i}
										data={data}
										index={i}
										onDrop={(ev: any) => {
											var from = parseInt(ev.dataTransfer.getData("item"))
											var to = i;
											var nueva = [...estructura]
											var item = nueva.splice(from, 1)[0]
											nueva.splice(to, 0, item)
											setEstructura(nueva)
										}}
										collapse={colapsarModulo}
										remove={eliminarModulo}
										update={actualizarModulo}
										nav={navegacion}
										fullNav={navegacionFull} />
								})}

								<div className="p-2 text-end">
									<ModuleSelector onSelect={(module: any) => { agregarModulo(module) }}><Button size="sm" variant="secondary"><PlusLg /></Button></ModuleSelector>
								</div>
							</Card.Body>} />
					</Card>}

				</Col>
				{data.get("redir")?.toString() === "-1" && <Col xs={4}>
					<Card className="shadow">
						<Card.Header className="bg-dark text-white">Preview</Card.Header>
						<Card.Body style={{ zoom: .7 }}>
							<Container>
								{estructura.map((data: ModuleData) => {
									return <React.Fragment key={data.Instance}>
										{data.Module && <data.Module.Component data={data.Data!} />}
									</React.Fragment>
								})}
							</Container>
						</Card.Body>
					</Card>
				</Col>}
			</Row>
		</Formulario>
	</>
}